import b from 'b_';
import { IconArrowLeft, IconArrowRight } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';
import { accessibleClick, accessibleMouseHover } from '@edu-frontend/modules/src/shared/lib/a11y';

import './course-journal__carousel-scroller.scss';

const DIRECTION_ARROW = {
    left: IconArrowLeft,
    right: IconArrowRight,
};

class CourseJournalCarouselScroller extends React.PureComponent {
    static propTypes = {
        direction: PropTypes.string,
        withArrow: PropTypes.bool,
    };

    static contextTypes = {
        addHoverCarouselScrollerListener: PropTypes.func.isRequired,
        addUnhoverCarouselScrollerListener: PropTypes.func.isRequired,
        hoverCaroselsScrollers: PropTypes.func.isRequired,
        scrollCarousels: PropTypes.func.isRequired,
        unhoverCaroselsScrollers: PropTypes.func.isRequired,
    };

    state = {
        hovered: false,
    };

    componentDidMount() {
        if (this.props.withArrow) {
            this.context.addHoverCarouselScrollerListener(this.onHover);
            this.context.addUnhoverCarouselScrollerListener(this.onUnhover);
        }
    }

    onHover = (type) => {
        if (type === this.props.direction) {
            this.setState({ hovered: true });
        }
    };

    onUnhover = (type) => {
        if (type === this.props.direction) {
            this.setState({ hovered: false });
        }
    };

    render() {
        const { direction, withArrow } = this.props;
        const className = b('course-journal', 'carousel-scroller', {
            [direction]: true,
            hovered: this.state.hovered,
        });

        return (
            <div
                className={className}
                {...accessibleClick(() => this.context.scrollCarousels(direction))}
                {...accessibleMouseHover({
                    onMouseEnter: () => this.context.hoverCaroselsScrollers(direction),
                    onMouseLeave: () => this.context.unhoverCaroselsScrollers(direction),
                    describedby: false,
                })}
            >
                {withArrow && React.createElement(DIRECTION_ARROW[direction])}
            </div>
        );
    }
}

export default CourseJournalCarouselScroller;
